document.addEventListener('DOMContentLoaded', function() {
    // Prevent click-through when navigation arrow is disabled.
    document.addEventListener('click', function(event) {
        const disabledArrow = event.target.closest('.CollectionShowcase__Arrow.swiper-button-disabled');
        if (!disabledArrow) return;
        event.preventDefault();
        event.stopPropagation();
    });

    const containers = document.querySelectorAll('.CollectionShowcase');
    
    // Helper function to initialize card swipers and swatch logic
    function initCardSwipers(parentEl) {
        // Initialize swipers inside cards
        const cardSwipers = parentEl.querySelectorAll('.CollectionSliderCard__InnerSlider');
        cardSwipers.forEach(cs => {
             if(cs.swiper) return;
             const paginationEl = cs.querySelector('.CollectionSliderCard__Pagination');
            const swiperInstance = new Swiper(cs, {
                nested: true,
                allowTouchMove: true,
                observer: true,
                observeParents: true,
                effect: 'fade',
                fadeEffect: { crossFade: true },
                pagination: {
                    el: paginationEl,
                    type: 'bullets',
                    clickable: true
                },
                autoplay: {
                    delay: 2000,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: false,
                    stopOnLastSlide: false
                },
                // Smooth scrolling optimizations for all devices
                touchEventsTarget: 'container',
                touchReleaseOnEdges: true,
                touchRatio: 1,
                touchAngle: 45,
                grabCursor: false,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 600,
                freeMode: false,
                freeModeSticky: false
            });
             // Start autoplay stopped - will be enabled on hover
             if(swiperInstance.autoplay) {
                 swiperInstance.autoplay.stop();
             }
        }); 
    }

    // Main Init Function with Retry
    function initShowcase() {
        if (typeof Swiper === 'undefined') {
            // Swiper library not loaded yet
            setTimeout(initShowcase, 100);
            return;
        }

        containers.forEach(container => {
            // Ensure we don't double init
            if (container.dataset.swiperInitialized) return;
            
            const swiperEl = container.querySelector('.CollectionShowcase__Swiper');
            if(!swiperEl) return;
            
            // Detect image width setting from data attribute
            const imageWidth = container.getAttribute('data-image-width');
            const hasNoImageWrapper = container.querySelector('.CollectionShowcase__Wrapper--no-image');

            console.log(imageWidth, "imageWidth from data attribute");
            // Default breakpoints
            let breakpointsConfig = {
                460: { slidesPerView: 1 },
                480: { slidesPerView: 2 },
                768: { slidesPerView: 2.2 },
                1024: { slidesPerView: 2.5 }
            };
            
            let defaultSlidesPerView = 1;
            
            // Adjust slidesPerView based on image width
            // Mobile (below 767px) always shows 2 products regardless of image width
            if (hasNoImageWrapper) {
                // No feature image: use a denser 3-column style grid on desktop
                breakpointsConfig = {
                    460: { slidesPerView: 1 },
                    480: { slidesPerView: 2 },
                    768: { slidesPerView: 2.4 },
                    1024: { slidesPerView: 3 },
                    1600: { slidesPerView: 3.2 }
                };
                defaultSlidesPerView = 1;
            } else if (imageWidth === '2/4') { 
                breakpointsConfig = {
                    460: { slidesPerView: 1 },
                    480: { slidesPerView: 2 },
                    768: { slidesPerView: 1 },
                    1024: { slidesPerView: 1.5 },
                    1200: { slidesPerView: 1.5 },
                    1700: { slidesPerView: 2.54 },
                    2000: { slidesPerView: 3.8 }
                };
                defaultSlidesPerView = 1;
            } else if (imageWidth === '3/4') {
                breakpointsConfig = {
                    460: { slidesPerView: 1 },
                    480: { slidesPerView: 2 },
                    768: { slidesPerView: 1 },
                    1024: { slidesPerView: 1 }, 
                    1700: { slidesPerView: 1.74 },
                    2000: { slidesPerView: 3 }
                };
                defaultSlidesPerView = 1;
            } else if (imageWidth === '1/4') {
                breakpointsConfig = {
                    460: { slidesPerView: 1 },
                    480: { slidesPerView: 2 },
                    768: { slidesPerView: 2.1 },
                    1024: { slidesPerView: 2.34 },
                    1700: { slidesPerView: 3.5 },
                    2000: { slidesPerView: 4.4 }
                };
                defaultSlidesPerView = 1;
            }
            
            new Swiper(swiperEl, {
                slidesPerView: defaultSlidesPerView,
                spaceBetween: 22,
                observer: true, 
                observeParents: true,
                breakpoints: breakpointsConfig,
                // Smooth scrolling optimizations for all devices (desktop and mobile)
                touchEventsTarget: 'container',
                touchReleaseOnEdges: true,
                touchRatio: 1,
                touchAngle: 45,
                grabCursor: false,
                resistance: true,
                resistanceRatio: 0.85,
                speed: 800,
                freeMode: false,
                freeModeSticky: false,
                // Optimized watchers for better performance
                watchOverflow: true,
                watchSlidesProgress: false,
                watchSlidesVisibility: false,
                preventClicks: true,
                preventClicksPropagation: true,
                // Smooth transition settings
                cssMode: false,
                simulateTouch: true,
                followFinger: true,
                threshold: 5,
                longSwipes: true,
                longSwipesRatio: 0.5,
                longSwipesMs: 300,
                navigation: {
                    nextEl: container.querySelector('.swiper-button-next'),
                    prevEl: container.querySelector('.swiper-button-prev'),
                },
                on: {
                    init: function(s) {
                         initCardSwipers(s.el);
                         // Small delay to ensure breakpoints are applied
                         setTimeout(function() {
                             updateProductCardProgressBar(s);
                         }, 50);
                    },
                    breakpoint: function(s) {
                         // Update progress bar when breakpoint changes
                         updateProductCardProgressBar(s);
                    },
                    slideChange: function(s) {
                         updateProductCardProgressBar(s);
                    },
                    reachEnd: function(s) {
                         // Ensure progress bar is 100% when reaching the end
                         updateProductCardProgressBar(s);
                    },
                    transitionStart: function(s) {
                         // Force hardware acceleration during transition
                         s.el.style.willChange = 'transform';
                    },
                    transitionEnd: function(s) {
                         // Remove will-change after transition
                         s.el.style.willChange = 'auto';
                         // Update progress bar after transition completes
                         updateProductCardProgressBar(s);
                    }
                }
            });

            bindMouseWheelToSlider(swiperEl.swiper, container);
            
            function updateProductCardProgressBar(swiper) {
                const bar = container.querySelector('.CollectionShowcase__ProgressBarFill');
                if (!bar) return; 
                
                // Get Swiper's progress (0 at start, 1 at end)
                let progress = swiper.progress || 0;
                progress = Math.max(0, Math.min(1, progress));
                
                // Calculate minimum width based on visible slides / total slides
                const totalSlides = swiper.slides ? swiper.slides.length : 0;
                
                // Get current slidesPerView based on window width and breakpoints
                let slidesPerView = swiper.params.slidesPerView || 1;
                
                // Check breakpoints to get the correct slidesPerView for current screen size
                if (swiper.params.breakpoints) {
                    const currentWidth = window.innerWidth;
                    const breakpoints = Object.keys(swiper.params.breakpoints)
                        .map(bp => parseInt(bp))
                        .sort((a, b) => b - a); // Sort descending
                    
                    // Find the matching breakpoint
                    for (let bp of breakpoints) {
                        if (currentWidth >= bp) {
                            const config = swiper.params.breakpoints[bp];
                            if (config && typeof config.slidesPerView === 'number') {
                                slidesPerView = config.slidesPerView;
                                break;
                            }
                        }
                    }
                }
                
                // Minimum progress = visible slides / total slides
                const minProgress = totalSlides > 0 ? Math.min(1, slidesPerView / totalSlides) : 0;
                
                // Map progress from [0,1] to [minProgress, 1]
                // When progress = 0, width = minProgress
                // When progress = 1, width = 1 (100%)
                const mappedProgress = minProgress + (progress * (1 - minProgress));
                
                // Set the progress bar width
                bar.style.width = (mappedProgress * 100) + '%';
            }
            
            container.dataset.swiperInitialized = 'true';
        });
    }

    function bindMouseWheelToSlider(swiper, showcaseContainer) {
        if (!swiper || !showcaseContainer || typeof window.CPBindHorizontalWheelScroll !== 'function') return;

        const wheelTarget = showcaseContainer.querySelector('.CollectionShowcase__SliderWrapper') || swiper.el;
        if (!wheelTarget) return;

        window.CPBindHorizontalWheelScroll({
            swiper: swiper,
            wheelTarget: wheelTarget,
            bindKey: 'wheelBound'
        });
    }

    // "Read Story" underline animation (directional) - Desktop only
    function initReadStoryHover() {
        const links = document.querySelectorAll('.CollectionShowcase__ReadStory:not(.CollectionShowcase__ReadStory--mobile)');
        links.forEach(function(link) {
            let isHovering = false;

            link.addEventListener('mouseenter', function() {
                isHovering = true;
                link.classList.remove('CollectionShowcase__ReadStory--hover-out');
                link.classList.add('CollectionShowcase__ReadStory--hover-in');
            });

            link.addEventListener('mouseleave', function() {
                isHovering = false;
                link.classList.remove('CollectionShowcase__ReadStory--hover-in');
                link.classList.add('CollectionShowcase__ReadStory--hover-out');
            }); 
        });
    }

    // Function to set padding-top for 3/4 width sections
    function setPaddingForThreeFourWidth() {
        // Only run on desktop (768px and above)
        if (window.innerWidth < 768) {
            return;
        }

        // Find all wrappers with Column--image-width-3-4 class
        const wrappers = document.querySelectorAll('.CollectionShowcase__Wrapper.Column--image-width-3-4');
        
        wrappers.forEach(wrapper => {
            // Find the header in the left column (for left_content_wrapped layout)
            const header = wrapper.querySelector('.CollectionShowcase__Header');
            
            // Find the right column
            const rightColumn = wrapper.querySelector('.CollectionShowcase__RightColumn');
            
            if (header && rightColumn) {
                // Get the height of the header
                const headerHeight = header.offsetHeight; 
                
                // Apply that height as padding-top to the right column
                rightColumn.style.paddingTop = headerHeight + 'px';
            }
        });
    }

    // Initialize padding on page load
    setPaddingForThreeFourWidth();

    // Recalculate after images load (for lazy-loaded images)
    window.addEventListener('load', function() {
        setPaddingForThreeFourWidth();
    });

    // Update padding on window resize (with debounce)
    let resizeTimeout;
    window.addEventListener('resize', function() {
        clearTimeout(resizeTimeout);
        resizeTimeout = setTimeout(function() {
            setPaddingForThreeFourWidth();
        }, 250);
    });

    initShowcase();
    initReadStoryHover();
});